<section class="error-message text-center padding-10">
  <small class="text-danger"
         [id]="idPrefix + 'general-error-message'"
         [innerHTML]="message | safeHtml"></small>
</section>
